import { useComposerAutosuggestControls } from '#pplx/frontend/apps/ask/composer-sdk-plugins/autosuggest/useComposerAutosuggestControls.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { invariant } from '#pplx/frontend/common/invariant.js';
import { createPlainTextComposerValue } from '#pplx/frontend/composer-sdk/createPlainTextComposerValue.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { useCallback, useMemo } from 'react';
/** Applies Home eligibility and placement to the shared Ask autosuggest controls used by Health. */
export function useHomeComposerAutosuggest({ autosuggestEnabled, querySource, composerRef, isTranscribing, onValueChange, setUserInput, ...controls }) {
    const { isMobileStyle, isMobileUserAgent } = useIsMobile();
    const inputAtBottom = !!import.meta.env.VITE_IS_SIDECAR_BUILD || (isMobileStyle && !isMobileUserAgent);
    const onFillInput = useCallback((query) => {
        invariant(composerRef.current !== null, 'Home Composer handle is required');
        setUserInput(query, createPlainTextComposerValue(query));
        composerRef.current.focus({ position: 'end' });
    }, [composerRef, setUserInput]);
    const autosuggest = useComposerAutosuggestControls({
        ...controls,
        autosuggestionsEnabled: autosuggestEnabled &&
            !import.meta.env.VITE_IS_SIDECAR_BUILD &&
            controls.selectedSearchMode !== SearchMode.ASI,
        fillInput: onFillInput,
        isTranscribing,
        querySource,
    });
    const { onComposerValueChange } = autosuggest;
    const handleValueChange = useCallback((state) => {
        onComposerValueChange(state);
        onValueChange(state);
    }, [onComposerValueChange, onValueChange]);
    const overlayPlacement = inputAtBottom
        ? 'above'
        : 'below';
    return useMemo(() => ({
        ...autosuggest,
        onComposerValueChange: handleValueChange,
        overlayPlacement,
    }), [autosuggest, handleValueChange, overlayPlacement]);
}
//# sourceMappingURL=useHomeComposerAutosuggest.js.map